/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Translate } from 'react-jhipster';

import MenuItem from 'app/shared/layout/menus/menu-item';

const EntitiesMenu = () => {
  return (
    <>
      {/* prettier-ignore */}
      <MenuItem icon="asterisk" to="/pharmacy-return-bill-payment">
        <Translate contentKey="global.menu.entities.pharmacyReturnBillPayment" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/hospital-op-bill-item">
        <Translate contentKey="global.menu.entities.hospitalOpBillItem" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/person-name">
        <Translate contentKey="global.menu.entities.personName" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/diaglab-sample-item-status">
        <Translate contentKey="global.menu.entities.diaglabSampleItemStatus" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/admission">
        <Translate contentKey="global.menu.entities.admission" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/admission-advice">
        <Translate contentKey="global.menu.entities.admissionAdvice" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/admission-em-contacts">
        <Translate contentKey="global.menu.entities.admissionEmContacts" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/aldrete-score">
        <Translate contentKey="global.menu.entities.aldreteScore" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/allergy-legend">
        <Translate contentKey="global.menu.entities.allergyLegend" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/allergy-symptom">
        <Translate contentKey="global.menu.entities.allergySymptom" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/apgar-score">
        <Translate contentKey="global.menu.entities.apgarScore" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/appointment-history">
        <Translate contentKey="global.menu.entities.appointmentHistory" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/appointment-status">
        <Translate contentKey="global.menu.entities.appointmentStatus" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/appointments">
        <Translate contentKey="global.menu.entities.appointments" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/assessment-answer">
        <Translate contentKey="global.menu.entities.assessmentAnswer" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/assessment-question">
        <Translate contentKey="global.menu.entities.assessmentQuestion" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/atendant">
        <Translate contentKey="global.menu.entities.atendant" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/bed">
        <Translate contentKey="global.menu.entities.bed" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/bed-allotment">
        <Translate contentKey="global.menu.entities.bedAllotment" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/behavioural-pain-score">
        <Translate contentKey="global.menu.entities.behaviouralPainScore" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/birth-history">
        <Translate contentKey="global.menu.entities.birthHistory" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/booking-type">
        <Translate contentKey="global.menu.entities.bookingType" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/cash-transaction">
        <Translate contentKey="global.menu.entities.cashTransaction" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/cholesterol">
        <Translate contentKey="global.menu.entities.cholesterol" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/chronic-condition">
        <Translate contentKey="global.menu.entities.chronicCondition" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/combousers">
        <Translate contentKey="global.menu.entities.combousers" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/concept-data-type">
        <Translate contentKey="global.menu.entities.conceptDataType" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/consumable">
        <Translate contentKey="global.menu.entities.consumable" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/consumable-group">
        <Translate contentKey="global.menu.entities.consumableGroup" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/consumable-order">
        <Translate contentKey="global.menu.entities.consumableOrder" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/consumable-order-item">
        <Translate contentKey="global.menu.entities.consumableOrderItem" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/contact-details">
        <Translate contentKey="global.menu.entities.contactDetails" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/device">
        <Translate contentKey="global.menu.entities.device" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/device-manufacurer">
        <Translate contentKey="global.menu.entities.deviceManufacurer" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/device-type">
        <Translate contentKey="global.menu.entities.deviceType" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/diag-lab">
        <Translate contentKey="global.menu.entities.diagLab" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/diaglab-equipment">
        <Translate contentKey="global.menu.entities.diaglabEquipment" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/diag-lab-panel">
        <Translate contentKey="global.menu.entities.diagLabPanel" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/diag-lab-panel-item">
        <Translate contentKey="global.menu.entities.diagLabPanelItem" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/diaglab-assistant">
        <Translate contentKey="global.menu.entities.diaglabAssistant" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/diaglab-bill">
        <Translate contentKey="global.menu.entities.diaglabBill" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/diaglab-bill-item">
        <Translate contentKey="global.menu.entities.diaglabBillItem" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/diaglab-bill-payment">
        <Translate contentKey="global.menu.entities.diaglabBillPayment" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/diaglab-history">
        <Translate contentKey="global.menu.entities.diaglabHistory" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/diaglab-pricing">
        <Translate contentKey="global.menu.entities.diaglabPricing" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/diaglab-sample-item">
        <Translate contentKey="global.menu.entities.diaglabSampleItem" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/diaglab-sample">
        <Translate contentKey="global.menu.entities.diaglabSample" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/diagnosis-history">
        <Translate contentKey="global.menu.entities.diagnosisHistory" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/discharge-summary">
        <Translate contentKey="global.menu.entities.dischargeSummary" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/doctor">
        <Translate contentKey="global.menu.entities.doctor" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/doctor-access">
        <Translate contentKey="global.menu.entities.doctorAccess" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/doctor-association">
        <Translate contentKey="global.menu.entities.doctorAssociation" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/doctor-availability">
        <Translate contentKey="global.menu.entities.doctorAvailability" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/doctor-charges">
        <Translate contentKey="global.menu.entities.doctorCharges" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/doctor-details">
        <Translate contentKey="global.menu.entities.doctorDetails" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/doctor-diaglab-association">
        <Translate contentKey="global.menu.entities.doctorDiaglabAssociation" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/doctor-especialty">
        <Translate contentKey="global.menu.entities.doctorEspecialty" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/doctor-hospital-association">
        <Translate contentKey="global.menu.entities.doctorHospitalAssociation" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/duration">
        <Translate contentKey="global.menu.entities.duration" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/equipment">
        <Translate contentKey="global.menu.entities.equipment" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/equipment-allotment">
        <Translate contentKey="global.menu.entities.equipmentAllotment" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/equipment-ip">
        <Translate contentKey="global.menu.entities.equipmentIp" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/equipment-ip-charges">
        <Translate contentKey="global.menu.entities.equipmentIpCharges" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/especialty">
        <Translate contentKey="global.menu.entities.especialty" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/flacc-score">
        <Translate contentKey="global.menu.entities.flaccScore" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/global-property">
        <Translate contentKey="global.menu.entities.globalProperty" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/gluco-user">
        <Translate contentKey="global.menu.entities.glucoUser" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/glucose">
        <Translate contentKey="global.menu.entities.glucose" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/growth-legend">
        <Translate contentKey="global.menu.entities.growthLegend" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/gynic-history">
        <Translate contentKey="global.menu.entities.gynicHistory" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/hb-1-ac">
        <Translate contentKey="global.menu.entities.hb1Ac" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/hospital">
        <Translate contentKey="global.menu.entities.hospital" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/hospital-access">
        <Translate contentKey="global.menu.entities.hospitalAccess" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/hospital-accountant">
        <Translate contentKey="global.menu.entities.hospitalAccountant" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/hospital-appointments">
        <Translate contentKey="global.menu.entities.hospitalAppointments" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/hospital-assistant">
        <Translate contentKey="global.menu.entities.hospitalAssistant" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/hospital-bill">
        <Translate contentKey="global.menu.entities.hospitalBill" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/hospital-bill-discount">
        <Translate contentKey="global.menu.entities.hospitalBillDiscount" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/hospital-bill-item">
        <Translate contentKey="global.menu.entities.hospitalBillItem" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/hospital-institution">
        <Translate contentKey="global.menu.entities.hospitalInstitution" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/hospital-manager">
        <Translate contentKey="global.menu.entities.hospitalManager" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/hospital-payment">
        <Translate contentKey="global.menu.entities.hospitalPayment" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/hospital-procedure">
        <Translate contentKey="global.menu.entities.hospitalProcedure" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/icd-10-diagnosis">
        <Translate contentKey="global.menu.entities.icd10Diagnosis" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/icd-10-procedure">
        <Translate contentKey="global.menu.entities.icd10Procedure" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/icd-details">
        <Translate contentKey="global.menu.entities.icdDetails" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/image-tests">
        <Translate contentKey="global.menu.entities.imageTests" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/implant">
        <Translate contentKey="global.menu.entities.implant" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/implant-group">
        <Translate contentKey="global.menu.entities.implantGroup" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/implant-order">
        <Translate contentKey="global.menu.entities.implantOrder" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/implant-order-item">
        <Translate contentKey="global.menu.entities.implantOrderItem" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/implant-property">
        <Translate contentKey="global.menu.entities.implantProperty" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/instance">
        <Translate contentKey="global.menu.entities.instance" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/institution">
        <Translate contentKey="global.menu.entities.institution" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/insurance-claim">
        <Translate contentKey="global.menu.entities.insuranceClaim" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/insurance-claim-history">
        <Translate contentKey="global.menu.entities.insuranceClaimHistory" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/insurance-claim-item">
        <Translate contentKey="global.menu.entities.insuranceClaimItem" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/insurance-policy">
        <Translate contentKey="global.menu.entities.insurancePolicy" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/intra-op-chart">
        <Translate contentKey="global.menu.entities.intraOpChart" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/intra-op-count">
        <Translate contentKey="global.menu.entities.intraOpCount" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/intra-op-nursing-record">
        <Translate contentKey="global.menu.entities.intraOpNursingRecord" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/intra-op-pack">
        <Translate contentKey="global.menu.entities.intraOpPack" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/intra-op-recovery">
        <Translate contentKey="global.menu.entities.intraOpRecovery" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/ketone">
        <Translate contentKey="global.menu.entities.ketone" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/lab-access">
        <Translate contentKey="global.menu.entities.labAccess" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/lab-department">
        <Translate contentKey="global.menu.entities.labDepartment" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/lab-department-item">
        <Translate contentKey="global.menu.entities.labDepartmentItem" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/lab-hospital-association">
        <Translate contentKey="global.menu.entities.labHospitalAssociation" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/lab-item-measure">
        <Translate contentKey="global.menu.entities.labItemMeasure" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/lab-prescription">
        <Translate contentKey="global.menu.entities.labPrescription" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/lab-test-category">
        <Translate contentKey="global.menu.entities.labTestCategory" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/lab-test-category-group">
        <Translate contentKey="global.menu.entities.labTestCategoryGroup" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/lab-test-category-item">
        <Translate contentKey="global.menu.entities.labTestCategoryItem" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/lab-test-group-item">
        <Translate contentKey="global.menu.entities.labTestGroupItem" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/lab-test-item">
        <Translate contentKey="global.menu.entities.labTestItem" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/lab-test-item-limit">
        <Translate contentKey="global.menu.entities.labTestItemLimit" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/mpps">
        <Translate contentKey="global.menu.entities.mpps" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/mwl-item">
        <Translate contentKey="global.menu.entities.mwlItem" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/meal">
        <Translate contentKey="global.menu.entities.meal" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/meal-advise">
        <Translate contentKey="global.menu.entities.mealAdvise" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/meal-details">
        <Translate contentKey="global.menu.entities.mealDetails" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/meal-nutrition">
        <Translate contentKey="global.menu.entities.mealNutrition" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/meal-plan">
        <Translate contentKey="global.menu.entities.mealPlan" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/meal-schedule">
        <Translate contentKey="global.menu.entities.mealSchedule" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/medical-association">
        <Translate contentKey="global.menu.entities.medicalAssociation" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/medical-history">
        <Translate contentKey="global.menu.entities.medicalHistory" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/medication-details">
        <Translate contentKey="global.menu.entities.medicationDetails" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/medication-medicines">
        <Translate contentKey="global.menu.entities.medicationMedicines" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/medication-schedule">
        <Translate contentKey="global.menu.entities.medicationSchedule" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/medication-schedule-details">
        <Translate contentKey="global.menu.entities.medicationScheduleDetails" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/medicine">
        <Translate contentKey="global.menu.entities.medicine" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/module-logo">
        <Translate contentKey="global.menu.entities.moduleLogo" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/nips-score">
        <Translate contentKey="global.menu.entities.nipsScore" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/nurse">
        <Translate contentKey="global.menu.entities.nurse" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/nursing-notes">
        <Translate contentKey="global.menu.entities.nursingNotes" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/nutrition-ip">
        <Translate contentKey="global.menu.entities.nutritionIp" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/nutrition-order">
        <Translate contentKey="global.menu.entities.nutritionOrder" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/nutrition-order-item">
        <Translate contentKey="global.menu.entities.nutritionOrderItem" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/nutrition-plan">
        <Translate contentKey="global.menu.entities.nutritionPlan" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/nutrition-plan-ip">
        <Translate contentKey="global.menu.entities.nutritionPlanIp" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/nutritionist">
        <Translate contentKey="global.menu.entities.nutritionist" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/nutrtion">
        <Translate contentKey="global.menu.entities.nutrtion" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/nutrtiontags">
        <Translate contentKey="global.menu.entities.nutrtiontags" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/obstetric-event">
        <Translate contentKey="global.menu.entities.obstetricEvent" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/op-medication">
        <Translate contentKey="global.menu.entities.opMedication" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/other-vitals">
        <Translate contentKey="global.menu.entities.otherVitals" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/paediatric-params">
        <Translate contentKey="global.menu.entities.paediatricParams" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/patient-condition">
        <Translate contentKey="global.menu.entities.patientCondition" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/patient-condition-check-up">
        <Translate contentKey="global.menu.entities.patientConditionCheckUp" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/patient-identifier-name">
        <Translate contentKey="global.menu.entities.patientIdentifierName" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/patient-identifier">
        <Translate contentKey="global.menu.entities.patientIdentifier" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/patient-identifier-type">
        <Translate contentKey="global.menu.entities.patientIdentifierType" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/patient-marker">
        <Translate contentKey="global.menu.entities.patientMarker" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/patient-nutrition-plan">
        <Translate contentKey="global.menu.entities.patientNutritionPlan" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/patient-procedure">
        <Translate contentKey="global.menu.entities.patientProcedure" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/patient-procedure-consumable">
        <Translate contentKey="global.menu.entities.patientProcedureConsumable" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/patient-procedure-implant">
        <Translate contentKey="global.menu.entities.patientProcedureImplant" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/patient-procedure-medicine">
        <Translate contentKey="global.menu.entities.patientProcedureMedicine" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/patient-procedure-order">
        <Translate contentKey="global.menu.entities.patientProcedureOrder" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/patient-procedure-plan">
        <Translate contentKey="global.menu.entities.patientProcedurePlan" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/patient-procedure-investigation">
        <Translate contentKey="global.menu.entities.patientProcedureInvestigation" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/patient-survey">
        <Translate contentKey="global.menu.entities.patientSurvey" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/patient-survey-sections">
        <Translate contentKey="global.menu.entities.patientSurveySections" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/patient-volunteer">
        <Translate contentKey="global.menu.entities.patientVolunteer" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/payment-scheme">
        <Translate contentKey="global.menu.entities.paymentScheme" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/patient-name">
        <Translate contentKey="global.menu.entities.patientName" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/pharmacist">
        <Translate contentKey="global.menu.entities.pharmacist" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/pharmacy">
        <Translate contentKey="global.menu.entities.pharmacy" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/pharmacy-access">
        <Translate contentKey="global.menu.entities.pharmacyAccess" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/pharmacy-bill">
        <Translate contentKey="global.menu.entities.pharmacyBill" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/pharmacy-bill-item">
        <Translate contentKey="global.menu.entities.pharmacyBillItem" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/pharmacy-bill-payment">
        <Translate contentKey="global.menu.entities.pharmacyBillPayment" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/pharmacy-consumable-bill-item">
        <Translate contentKey="global.menu.entities.pharmacyConsumableBillItem" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/pharmacy-consumable-refund-bill-item">
        <Translate contentKey="global.menu.entities.pharmacyConsumableRefundBillItem" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/pharmacy-consumable-stock">
        <Translate contentKey="global.menu.entities.pharmacyConsumableStock" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/pharmacy-drug-brand-names">
        <Translate contentKey="global.menu.entities.pharmacyDrugBrandNames" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/pharmacy-history">
        <Translate contentKey="global.menu.entities.pharmacyHistory" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/pharmacy-hospital-association">
        <Translate contentKey="global.menu.entities.pharmacyHospitalAssociation" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/pharmacy-implant-bill-item">
        <Translate contentKey="global.menu.entities.pharmacyImplantBillItem" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/pharmacy-implant-refund-bill-item">
        <Translate contentKey="global.menu.entities.pharmacyImplantRefundBillItem" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/pharmacy-implant-stock">
        <Translate contentKey="global.menu.entities.pharmacyImplantStock" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/pharmacy-payment-history">
        <Translate contentKey="global.menu.entities.pharmacyPaymentHistory" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/pharmacy-refund-bill">
        <Translate contentKey="global.menu.entities.pharmacyRefundBill" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/pharmacy-refund-bill-item">
        <Translate contentKey="global.menu.entities.pharmacyRefundBillItem" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/pharmacy-refund-payment">
        <Translate contentKey="global.menu.entities.pharmacyRefundPayment" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/pharmacy-stock">
        <Translate contentKey="global.menu.entities.pharmacyStock" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/pharmacy-stock-bill">
        <Translate contentKey="global.menu.entities.pharmacyStockBill" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/pharmacy-suppliers">
        <Translate contentKey="global.menu.entities.pharmacySuppliers" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/physio-category">
        <Translate contentKey="global.menu.entities.physioCategory" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/physio-category-item">
        <Translate contentKey="global.menu.entities.physioCategoryItem" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/physio-item">
        <Translate contentKey="global.menu.entities.physioItem" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/physio-order">
        <Translate contentKey="global.menu.entities.physioOrder" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/physio-order-item">
        <Translate contentKey="global.menu.entities.physioOrderItem" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/physio-therapist">
        <Translate contentKey="global.menu.entities.physioTherapist" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/post-op-instruction">
        <Translate contentKey="global.menu.entities.postOpInstruction" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/post-op-recovery-record">
        <Translate contentKey="global.menu.entities.postOpRecoveryRecord" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/post-op-surgeon-notes">
        <Translate contentKey="global.menu.entities.postOpSurgeonNotes" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/post-op-recovery">
        <Translate contentKey="global.menu.entities.postOpRecovery" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/post-op-recovery-discharge">
        <Translate contentKey="global.menu.entities.postOpRecoveryDischarge" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/pre-assessment">
        <Translate contentKey="global.menu.entities.preAssessment" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/pre-op-time-out">
        <Translate contentKey="global.menu.entities.preOpTimeOut" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/pre-op-addl-assessment">
        <Translate contentKey="global.menu.entities.preOpAddlAssessment" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/pre-op-anaesthesia-chart">
        <Translate contentKey="global.menu.entities.preOpAnaesthesiaChart" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/pre-op-assessment">
        <Translate contentKey="global.menu.entities.preOpAssessment" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/pre-op-check-list">
        <Translate contentKey="global.menu.entities.preOpCheckList" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/pre-op-instructions">
        <Translate contentKey="global.menu.entities.preOpInstructions" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/pre-op-review-pac">
        <Translate contentKey="global.menu.entities.preOpReviewPac" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/pre-op-sign-in">
        <Translate contentKey="global.menu.entities.preOpSignIn" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/prescription">
        <Translate contentKey="global.menu.entities.prescription" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/prescription-spec-vital">
        <Translate contentKey="global.menu.entities.prescriptionSpecVital" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/pressure">
        <Translate contentKey="global.menu.entities.pressure" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/procedure-blood-products">
        <Translate contentKey="global.menu.entities.procedureBloodProducts" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/procedure-consumable">
        <Translate contentKey="global.menu.entities.procedureConsumable" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/procedure-implant">
        <Translate contentKey="global.menu.entities.procedureImplant" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/procedure-medicine">
        <Translate contentKey="global.menu.entities.procedureMedicine" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/procedure-monitors">
        <Translate contentKey="global.menu.entities.procedureMonitors" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/procedure-price">
        <Translate contentKey="global.menu.entities.procedurePrice" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/procedure-investigation">
        <Translate contentKey="global.menu.entities.procedureInvestigation" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/provided-item">
        <Translate contentKey="global.menu.entities.providedItem" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/radiology-bill-item">
        <Translate contentKey="global.menu.entities.radiologyBillItem" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/radiology-pricing">
        <Translate contentKey="global.menu.entities.radiologyPricing" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/radiology-report">
        <Translate contentKey="global.menu.entities.radiologyReport" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/radiology-report-template">
        <Translate contentKey="global.menu.entities.radiologyReportTemplate" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/radiology-study">
        <Translate contentKey="global.menu.entities.radiologyStudy" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/recipe">
        <Translate contentKey="global.menu.entities.recipe" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/recipe-tags">
        <Translate contentKey="global.menu.entities.recipeTags" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/referral">
        <Translate contentKey="global.menu.entities.referral" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/relation">
        <Translate contentKey="global.menu.entities.relation" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/relatives">
        <Translate contentKey="global.menu.entities.relatives" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/reminder-options">
        <Translate contentKey="global.menu.entities.reminderOptions" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/reminders">
        <Translate contentKey="global.menu.entities.reminders" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/roles">
        <Translate contentKey="global.menu.entities.roles" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/room">
        <Translate contentKey="global.menu.entities.room" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/saluation">
        <Translate contentKey="global.menu.entities.saluation" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/series">
        <Translate contentKey="global.menu.entities.series" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/speciality-vitals">
        <Translate contentKey="global.menu.entities.specialityVitals" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/study">
        <Translate contentKey="global.menu.entities.study" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/subscription-billing">
        <Translate contentKey="global.menu.entities.subscriptionBilling" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/subscription-payment">
        <Translate contentKey="global.menu.entities.subscriptionPayment" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/subscription-plan">
        <Translate contentKey="global.menu.entities.subscriptionPlan" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/survey-answer">
        <Translate contentKey="global.menu.entities.surveyAnswer" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/survey-comments">
        <Translate contentKey="global.menu.entities.surveyComments" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/survey-headers">
        <Translate contentKey="global.menu.entities.surveyHeaders" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/survey-input-type">
        <Translate contentKey="global.menu.entities.surveyInputType" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/survey-option-choice">
        <Translate contentKey="global.menu.entities.surveyOptionChoice" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/survey-option-group">
        <Translate contentKey="global.menu.entities.surveyOptionGroup" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/survey-question">
        <Translate contentKey="global.menu.entities.surveyQuestion" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/survey-question-option">
        <Translate contentKey="global.menu.entities.surveyQuestionOption" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/survey-sections">
        <Translate contentKey="global.menu.entities.surveySections" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/survey-units-of-measure">
        <Translate contentKey="global.menu.entities.surveyUnitsOfMeasure" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/template-diagnosis">
        <Translate contentKey="global.menu.entities.templateDiagnosis" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/template-investigation">
        <Translate contentKey="global.menu.entities.templateInvestigation" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/template-medication">
        <Translate contentKey="global.menu.entities.templateMedication" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/template-prescription">
        <Translate contentKey="global.menu.entities.templatePrescription" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/template-schedule">
        <Translate contentKey="global.menu.entities.templateSchedule" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/treatment-history">
        <Translate contentKey="global.menu.entities.treatmentHistory" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/treatment-notes">
        <Translate contentKey="global.menu.entities.treatmentNotes" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/treatment-plan">
        <Translate contentKey="global.menu.entities.treatmentPlan" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/user-additional-history">
        <Translate contentKey="global.menu.entities.userAdditionalHistory" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/user-allergies">
        <Translate contentKey="global.menu.entities.userAllergies" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/user-lab-item-enum">
        <Translate contentKey="global.menu.entities.userLabItemEnum" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/user-lab-test-item">
        <Translate contentKey="global.menu.entities.userLabTestItem" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/user-panel-item">
        <Translate contentKey="global.menu.entities.userPanelItem" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/user-roles">
        <Translate contentKey="global.menu.entities.userRoles" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/user-vaccination-schedule-details">
        <Translate contentKey="global.menu.entities.userVaccinationScheduleDetails" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/vaccination">
        <Translate contentKey="global.menu.entities.vaccination" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/vaccination-schedule">
        <Translate contentKey="global.menu.entities.vaccinationSchedule" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/vaccination-schedule-details">
        <Translate contentKey="global.menu.entities.vaccinationScheduleDetails" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/vitals">
        <Translate contentKey="global.menu.entities.vitals" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/volunteer-visits">
        <Translate contentKey="global.menu.entities.volunteerVisits" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/ward">
        <Translate contentKey="global.menu.entities.ward" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/ward-charges">
        <Translate contentKey="global.menu.entities.wardCharges" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/weight">
        <Translate contentKey="global.menu.entities.weight" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/wong-bakers-pain-score">
        <Translate contentKey="global.menu.entities.wongBakersPainScore" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/entity-attribute">
        <Translate contentKey="global.menu.entities.entityAttribute" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/pharmacy-limit">
        <Translate contentKey="global.menu.entities.pharmacyLimit" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/operation-theatre">
        <Translate contentKey="global.menu.entities.operationTheatre" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/surgical-appointment">
        <Translate contentKey="global.menu.entities.surgicalAppointment" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/surgical-appointment-attribute-type">
        <Translate contentKey="global.menu.entities.surgicalAppointmentAttributeType" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/surgical-appointment-attribute">
        <Translate contentKey="global.menu.entities.surgicalAppointmentAttribute" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/pharmacy-return-bill">
        <Translate contentKey="global.menu.entities.pharmacyReturnBill" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/pharmacy-return-bill-item">
        <Translate contentKey="global.menu.entities.pharmacyReturnBillItem" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/pharmacy-consumable-return-bill-item">
        <Translate contentKey="global.menu.entities.pharmacyConsumableReturnBillItem" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/pharmacy-implant-return-bill-item">
        <Translate contentKey="global.menu.entities.pharmacyImplantReturnBillItem" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/pharmacy-vendor-payment-tracker">
        <Translate contentKey="global.menu.entities.pharmacyVendorPaymentTracker" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/op-charge">
        <Translate contentKey="global.menu.entities.opCharge" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/pharmacy-credit">
        <Translate contentKey="global.menu.entities.pharmacyCredit" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/package-subscription">
        <Translate contentKey="global.menu.entities.packageSubscription" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/package-subscriber">
        <Translate contentKey="global.menu.entities.packageSubscriber" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/package-subscription-discount">
        <Translate contentKey="global.menu.entities.packageSubscriptionDiscount" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/package-payment-history">
        <Translate contentKey="global.menu.entities.packagePaymentHistory" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/patient-access-group">
        <Translate contentKey="global.menu.entities.patientAccessGroup" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/pharmacy-audit-summary">
        <Translate contentKey="global.menu.entities.pharmacyAuditSummary" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/pharmacy-audit-item">
        <Translate contentKey="global.menu.entities.pharmacyAuditItem" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/package-medicine">
        <Translate contentKey="global.menu.entities.packageMedicine" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/customer-care-executive">
        <Translate contentKey="global.menu.entities.customerCareExecutive" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/event-image">
        <Translate contentKey="global.menu.entities.eventImage" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/dental-tooth">
        <Translate contentKey="global.menu.entities.dentalTooth" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/dental-surface">
        <Translate contentKey="global.menu.entities.dentalSurface" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/dental-tooth-surface">
        <Translate contentKey="global.menu.entities.dentalToothSurface" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/dental-mouth-item">
        <Translate contentKey="global.menu.entities.dentalMouthItem" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/dental-surface-erosion">
        <Translate contentKey="global.menu.entities.dentalSurfaceErosion" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/dental-exam-and-treatment">
        <Translate contentKey="global.menu.entities.dentalExamAndTreatment" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/pharmacy-kit">
        <Translate contentKey="global.menu.entities.pharmacyKit" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/pharmacy-kit-item">
        <Translate contentKey="global.menu.entities.pharmacyKitItem" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/procedure-episode">
        <Translate contentKey="global.menu.entities.procedureEpisode" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/patient-procedure-episode">
        <Translate contentKey="global.menu.entities.patientProcedureEpisode" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/treatment-procedure">
        <Translate contentKey="global.menu.entities.treatmentProcedure" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/pharmacy-stock-closure">
        <Translate contentKey="global.menu.entities.pharmacyStockClosure" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/lens-specification">
        <Translate contentKey="global.menu.entities.lensSpecification" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/lens-prescription">
        <Translate contentKey="global.menu.entities.lensPrescription" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/op-procedure-order">
        <Translate contentKey="global.menu.entities.opProcedureOrder" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/op-procedure-order-item">
        <Translate contentKey="global.menu.entities.opProcedureOrderItem" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/appointment-episode">
        <Translate contentKey="global.menu.entities.appointmentEpisode" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/bleeding">
        <Translate contentKey="global.menu.entities.bleeding" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/cervix">
        <Translate contentKey="global.menu.entities.cervix" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/cycle-day">
        <Translate contentKey="global.menu.entities.cycleDay" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/family-history">
        <Translate contentKey="global.menu.entities.familyHistory" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/gynaec-history">
        <Translate contentKey="global.menu.entities.gynaecHistory" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/medication-history">
        <Translate contentKey="global.menu.entities.medicationHistory" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/menses-event">
        <Translate contentKey="global.menu.entities.mensesEvent" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/mucus">
        <Translate contentKey="global.menu.entities.mucus" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/ovulation">
        <Translate contentKey="global.menu.entities.ovulation" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/pain">
        <Translate contentKey="global.menu.entities.pain" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/past-medical-history">
        <Translate contentKey="global.menu.entities.pastMedicalHistory" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/patient-symptom-history">
        <Translate contentKey="global.menu.entities.patientSymptomHistory" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/post-delivery-monitoring">
        <Translate contentKey="global.menu.entities.postDeliveryMonitoring" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/pregnancy-case">
        <Translate contentKey="global.menu.entities.pregnancyCase" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/pregnancy-prescription">
        <Translate contentKey="global.menu.entities.pregnancyPrescription" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/pregnancy-vaccine">
        <Translate contentKey="global.menu.entities.pregnancyVaccine" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/habits-history">
        <Translate contentKey="global.menu.entities.habitsHistory" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/sexual-history">
        <Translate contentKey="global.menu.entities.sexualHistory" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/speciality-symptom-preferences">
        <Translate contentKey="global.menu.entities.specialitySymptomPreferences" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/surgical-history">
        <Translate contentKey="global.menu.entities.surgicalHistory" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/symptom">
        <Translate contentKey="global.menu.entities.symptom" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/temperature">
        <Translate contentKey="global.menu.entities.temperature" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/trimester-observation">
        <Translate contentKey="global.menu.entities.trimesterObservation" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/patient-attribute-type">
        <Translate contentKey="global.menu.entities.patientAttributeType" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/patient-attribute">
        <Translate contentKey="global.menu.entities.patientAttribute" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/paramedic">
        <Translate contentKey="global.menu.entities.paramedic" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/paramedic-referral">
        <Translate contentKey="global.menu.entities.paramedicReferral" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/paramedic-referral-charge">
        <Translate contentKey="global.menu.entities.paramedicReferralCharge" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/paramedic-referral-payment">
        <Translate contentKey="global.menu.entities.paramedicReferralPayment" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/paramedic-hospital-association">
        <Translate contentKey="global.menu.entities.paramedicHospitalAssociation" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/url-slug">
        <Translate contentKey="global.menu.entities.urlSlug" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/facility-location">
        <Translate contentKey="global.menu.entities.facilityLocation" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/paramedic-access">
        <Translate contentKey="global.menu.entities.paramedicAccess" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/pharmacy-stock-indent-item">
        <Translate contentKey="global.menu.entities.pharmacyStockIndentItem" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/pharmacy-stock-indent-map">
        <Translate contentKey="global.menu.entities.pharmacyStockIndentMap" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/diag-lab-inventory-type">
        <Translate contentKey="global.menu.entities.diagLabInventoryType" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/diag-lab-inventory">
        <Translate contentKey="global.menu.entities.diagLabInventory" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/diag-lab-inventory-investigation">
        <Translate contentKey="global.menu.entities.diagLabInventoryInvestigation" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/diag-lab-supplier">
        <Translate contentKey="global.menu.entities.diagLabSupplier" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/pharmacy-stock-indent">
        <Translate contentKey="global.menu.entities.pharmacyStockIndent" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/diag-lab-inventory-checkout">
        <Translate contentKey="global.menu.entities.diagLabInventoryCheckout" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/language">
        <Translate contentKey="global.menu.entities.language" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/trimester">
        <Translate contentKey="global.menu.entities.trimester" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/paramedic-order">
        <Translate contentKey="global.menu.entities.paramedicOrder" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/doctor-language">
        <Translate contentKey="global.menu.entities.doctorLanguage" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/labor-incident">
        <Translate contentKey="global.menu.entities.laborIncident" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/labor-progression">
        <Translate contentKey="global.menu.entities.laborProgression" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/trimester-observation-param">
        <Translate contentKey="global.menu.entities.trimesterObservationParam" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/spec-vital-result">
        <Translate contentKey="global.menu.entities.specVitalResult" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/admission-aux-patient">
        <Translate contentKey="global.menu.entities.admissionAuxPatient" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/admission-consultant">
        <Translate contentKey="global.menu.entities.admissionConsultant" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/gynaec-checklist">
        <Translate contentKey="global.menu.entities.gynaecChecklist" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/patient-category">
        <Translate contentKey="global.menu.entities.patientCategory" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/misc-charges">
        <Translate contentKey="global.menu.entities.miscCharges" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/hospital-patient-category-attributes">
        <Translate contentKey="global.menu.entities.hospitalPatientCategoryAttributes" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/hosp-patient-cat-misc-charges">
        <Translate contentKey="global.menu.entities.hospPatientCatMiscCharges" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/hospital-patient-attribute">
        <Translate contentKey="global.menu.entities.hospitalPatientAttribute" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/doctor-hospital-attribute">
        <Translate contentKey="global.menu.entities.doctorHospitalAttribute" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/day-off">
        <Translate contentKey="global.menu.entities.dayOff" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/department">
        <Translate contentKey="global.menu.entities.department" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/nurse-department">
        <Translate contentKey="global.menu.entities.nurseDepartment" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/department-need">
        <Translate contentKey="global.menu.entities.departmentNeed" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/nurse-attribute">
        <Translate contentKey="global.menu.entities.nurseAttribute" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/schedule">
        <Translate contentKey="global.menu.entities.schedule" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/shift">
        <Translate contentKey="global.menu.entities.shift" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/department-ward">
        <Translate contentKey="global.menu.entities.departmentWard" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/payment-community">
        <Translate contentKey="global.menu.entities.paymentCommunity" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/scheme-community">
        <Translate contentKey="global.menu.entities.schemeCommunity" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/department-speciality">
        <Translate contentKey="global.menu.entities.departmentSpeciality" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/diag-lab-inventory-bill">
        <Translate contentKey="global.menu.entities.diagLabInventoryBill" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/symptom-attribute-preference">
        <Translate contentKey="global.menu.entities.symptomAttributePreference" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/symptom-attribute">
        <Translate contentKey="global.menu.entities.symptomAttribute" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/patient-symptom-attribute">
        <Translate contentKey="global.menu.entities.patientSymptomAttribute" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/concept-terms">
        <Translate contentKey="global.menu.entities.conceptTerms" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/user-attribute">
        <Translate contentKey="global.menu.entities.userAttribute" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/pharmacy-consumer">
        <Translate contentKey="global.menu.entities.pharmacyConsumer" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/pharmacy-external-order">
        <Translate contentKey="global.menu.entities.pharmacyExternalOrder" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/pharmacy-external-order-item">
        <Translate contentKey="global.menu.entities.pharmacyExternalOrderItem" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/pharmacy-external-order-shipment">
        <Translate contentKey="global.menu.entities.pharmacyExternalOrderShipment" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/pharmacy-external-order-shipment-item">
        <Translate contentKey="global.menu.entities.pharmacyExternalOrderShipmentItem" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/eye">
        <Translate contentKey="global.menu.entities.eye" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/pharmacy-misc-bill-item">
        <Translate contentKey="global.menu.entities.pharmacyMiscBillItem" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/tumor-measurement">
        <Translate contentKey="global.menu.entities.tumorMeasurement" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/clinical-dictionary-type">
        <Translate contentKey="global.menu.entities.clinicalDictionaryType" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/clinical-dictionary">
        <Translate contentKey="global.menu.entities.clinicalDictionary" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/tumor">
        <Translate contentKey="global.menu.entities.tumor" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/tumor-source">
        <Translate contentKey="global.menu.entities.tumorSource" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/treatment-template">
        <Translate contentKey="global.menu.entities.treatmentTemplate" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/treatment-template-component">
        <Translate contentKey="global.menu.entities.treatmentTemplateComponent" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/regimen">
        <Translate contentKey="global.menu.entities.regimen" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/regimen-checklist-item">
        <Translate contentKey="global.menu.entities.regimenChecklistItem" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/radiation-type">
        <Translate contentKey="global.menu.entities.radiationType" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/radiation-technique">
        <Translate contentKey="global.menu.entities.radiationTechnique" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/dosage-guideline">
        <Translate contentKey="global.menu.entities.dosageGuideline" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/dosage-dilution">
        <Translate contentKey="global.menu.entities.dosageDilution" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/frequency">
        <Translate contentKey="global.menu.entities.frequency" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/sequence">
        <Translate contentKey="global.menu.entities.sequence" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/regimen-drug">
        <Translate contentKey="global.menu.entities.regimenDrug" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/radiation-session">
        <Translate contentKey="global.menu.entities.radiationSession" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/organ-at-risk">
        <Translate contentKey="global.menu.entities.organAtRisk" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/radiation-constraint">
        <Translate contentKey="global.menu.entities.radiationConstraint" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/radiation-beam-parameter">
        <Translate contentKey="global.menu.entities.radiationBeamParameter" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/radiation-dosimetry">
        <Translate contentKey="global.menu.entities.radiationDosimetry" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/regimen-cycle">
        <Translate contentKey="global.menu.entities.regimenCycle" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/regimen-adverse-event">
        <Translate contentKey="global.menu.entities.regimenAdverseEvent" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/drug-constraint">
        <Translate contentKey="global.menu.entities.drugConstraint" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/treatment-delivery-plan">
        <Translate contentKey="global.menu.entities.treatmentDeliveryPlan" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/treatment-regimen">
        <Translate contentKey="global.menu.entities.treatmentRegimen" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/treatment-cycle">
        <Translate contentKey="global.menu.entities.treatmentCycle" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/treatment-cycle-check-list-item">
        <Translate contentKey="global.menu.entities.treatmentCycleCheckListItem" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/treatment-drug">
        <Translate contentKey="global.menu.entities.treatmentDrug" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/treatment-radiation">
        <Translate contentKey="global.menu.entities.treatmentRadiation" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/treatment-radiation-beam-param">
        <Translate contentKey="global.menu.entities.treatmentRadiationBeamParam" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/treatment-radiation-dosimetry">
        <Translate contentKey="global.menu.entities.treatmentRadiationDosimetry" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/treatment-organ-at-risk">
        <Translate contentKey="global.menu.entities.treatmentOrganAtRisk" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/treatment-tumor">
        <Translate contentKey="global.menu.entities.treatmentTumor" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/treatment-radiation-technique">
        <Translate contentKey="global.menu.entities.treatmentRadiationTechnique" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/treatment-contouring">
        <Translate contentKey="global.menu.entities.treatmentContouring" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/treatment-assessment">
        <Translate contentKey="global.menu.entities.treatmentAssessment" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/treatment-adverse-event">
        <Translate contentKey="global.menu.entities.treatmentAdverseEvent" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/tumor-board">
        <Translate contentKey="global.menu.entities.tumorBoard" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/tumor-board-member">
        <Translate contentKey="global.menu.entities.tumorBoardMember" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/tumor-staging">
        <Translate contentKey="global.menu.entities.tumorStaging" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/tumor-board-occurrence-participant">
        <Translate contentKey="global.menu.entities.tumorBoardOccurrenceParticipant" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/tumor-board-outcome">
        <Translate contentKey="global.menu.entities.tumorBoardOutcome" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/tumor-board-participant-outcome">
        <Translate contentKey="global.menu.entities.tumorBoardParticipantOutcome" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/tumor-board-referral">
        <Translate contentKey="global.menu.entities.tumorBoardReferral" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/tumor-board-occurrence">
        <Translate contentKey="global.menu.entities.tumorBoardOccurrence" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/tumor-board-patient">
        <Translate contentKey="global.menu.entities.tumorBoardPatient" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/doctor-availability-slot">
        <Translate contentKey="global.menu.entities.doctorAvailabilitySlot" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/bed-allotment-charge">
        <Translate contentKey="global.menu.entities.bedAllotmentCharge" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/equipment-allotment-charge">
        <Translate contentKey="global.menu.entities.equipmentAllotmentCharge" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/patient-procedure-charge">
        <Translate contentKey="global.menu.entities.patientProcedureCharge" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/product-tag">
        <Translate contentKey="global.menu.entities.productTag" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/tenant-payment-gateway">
        <Translate contentKey="global.menu.entities.tenantPaymentGateway" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/payment-gateway">
        <Translate contentKey="global.menu.entities.paymentGateway" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/tenant-gateway-transaction">
        <Translate contentKey="global.menu.entities.tenantGatewayTransaction" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/pharmacy-supplier-attribute">
        <Translate contentKey="global.menu.entities.pharmacySupplierAttribute" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/intra-op-investigation">
        <Translate contentKey="global.menu.entities.intraOpInvestigation" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/product-attribute-type">
        <Translate contentKey="global.menu.entities.productAttributeType" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/product-attribute">
        <Translate contentKey="global.menu.entities.productAttribute" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/sample-container-type">
        <Translate contentKey="global.menu.entities.sampleContainerType" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/hospital-procedure-speciality">
        <Translate contentKey="global.menu.entities.hospitalProcedureSpeciality" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/work-flow-protocol">
        <Translate contentKey="global.menu.entities.workFlowProtocol" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/work-flow-step">
        <Translate contentKey="global.menu.entities.workFlowStep" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/work-flow-protocol-log">
        <Translate contentKey="global.menu.entities.workFlowProtocolLog" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/accounting-currency">
        <Translate contentKey="global.menu.entities.accountingCurrency" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/accounting-transaction">
        <Translate contentKey="global.menu.entities.accountingTransaction" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/accounting-reconciliation">
        <Translate contentKey="global.menu.entities.accountingReconciliation" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/accounting-collection-ledger">
        <Translate contentKey="global.menu.entities.accountingCollectionLedger" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/accounting-transaction-bill">
        <Translate contentKey="global.menu.entities.accountingTransactionBill" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/accounting-expense-ledger">
        <Translate contentKey="global.menu.entities.accountingExpenseLedger" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/accounting-tax">
        <Translate contentKey="global.menu.entities.accountingTax" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/work-flow-step-log">
        <Translate contentKey="global.menu.entities.workFlowStepLog" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/accounting-bank-account">
        <Translate contentKey="global.menu.entities.accountingBankAccount" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/pharmacy-sale-credit">
        <Translate contentKey="global.menu.entities.pharmacySaleCredit" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/sample-container-test-sample">
        <Translate contentKey="global.menu.entities.sampleContainerTestSample" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/operation-theatre-equipment">
        <Translate contentKey="global.menu.entities.operationTheatreEquipment" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/pharmacy-sale-credit-payment-tracker">
        <Translate contentKey="global.menu.entities.pharmacySaleCreditPaymentTracker" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/diaglab-department-access">
        <Translate contentKey="global.menu.entities.diaglabDepartmentAccess" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/lab-test-item-attribute">
        <Translate contentKey="global.menu.entities.labTestItemAttribute" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/rx-calculator-formula">
        <Translate contentKey="global.menu.entities.rxCalculatorFormula" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/diaglab-test-threshold">
        <Translate contentKey="global.menu.entities.diaglabTestThreshold" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/treatment-session-vitals">
        <Translate contentKey="global.menu.entities.treatmentSessionVitals" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/regimen-investigation">
        <Translate contentKey="global.menu.entities.regimenInvestigation" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/treatment-regimen-investigation">
        <Translate contentKey="global.menu.entities.treatmentRegimenInvestigation" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/treatment-regimen-investigation-obs">
        <Translate contentKey="global.menu.entities.treatmentRegimenInvestigationObs" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/catalog-definitions">
        <Translate contentKey="global.menu.entities.catalogDefinitions" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/organism">
        <Translate contentKey="global.menu.entities.organism" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/antibiotic">
        <Translate contentKey="global.menu.entities.antibiotic" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/lab-test-item-organism-antibiotic">
        <Translate contentKey="global.menu.entities.labTestItemOrganismAntibiotic" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/patient-organism-antibiotic-susceptibility">
        <Translate contentKey="global.menu.entities.patientOrganismAntibioticSusceptibility" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/resistance-trend">
        <Translate contentKey="global.menu.entities.resistanceTrend" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/blood-bank-inventory">
        <Translate contentKey="global.menu.entities.bloodBankInventory" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/blood-bank-request">
        <Translate contentKey="global.menu.entities.bloodBankRequest" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/blood-inventory-request-map">
        <Translate contentKey="global.menu.entities.bloodInventoryRequestMap" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/blood-bank">
        <Translate contentKey="global.menu.entities.bloodBank" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/blood-bank-employee">
        <Translate contentKey="global.menu.entities.bloodBankEmployee" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/blood-donation">
        <Translate contentKey="global.menu.entities.bloodDonation" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/blood-donor-fitness">
        <Translate contentKey="global.menu.entities.bloodDonorFitness" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/health-camp">
        <Translate contentKey="global.menu.entities.healthCamp" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/blood-inventory-investigation">
        <Translate contentKey="global.menu.entities.bloodInventoryInvestigation" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/blood-bank-investigation-list">
        <Translate contentKey="global.menu.entities.bloodBankInvestigationList" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/blood-bank-access">
        <Translate contentKey="global.menu.entities.bloodBankAccess" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/blood-bank-association">
        <Translate contentKey="global.menu.entities.bloodBankAssociation" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/blood-bank-adverse-event">
        <Translate contentKey="global.menu.entities.bloodBankAdverseEvent" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/integration-channel">
        <Translate contentKey="global.menu.entities.integrationChannel" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/integration-endpoint">
        <Translate contentKey="global.menu.entities.integrationEndpoint" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/integration-endpoint-attribute">
        <Translate contentKey="global.menu.entities.integrationEndpointAttribute" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/integration-template">
        <Translate contentKey="global.menu.entities.integrationTemplate" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/tenant-integration-channel">
        <Translate contentKey="global.menu.entities.tenantIntegrationChannel" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/tenant-integration-endpoint-attribute">
        <Translate contentKey="global.menu.entities.tenantIntegrationEndpointAttribute" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/tenant-integration-template">
        <Translate contentKey="global.menu.entities.tenantIntegrationTemplate" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/communication-log">
        <Translate contentKey="global.menu.entities.communicationLog" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/data-category">
        <Translate contentKey="global.menu.entities.dataCategory" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/integration-template-category">
        <Translate contentKey="global.menu.entities.integrationTemplateCategory" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/tenant-integration-template-category">
        <Translate contentKey="global.menu.entities.tenantIntegrationTemplateCategory" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/hospital-procedure-item">
        <Translate contentKey="global.menu.entities.hospitalProcedureItem" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/health-camp-participant">
        <Translate contentKey="global.menu.entities.healthCampParticipant" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/health-camp-transaction">
        <Translate contentKey="global.menu.entities.healthCampTransaction" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/approved-refund">
        <Translate contentKey="global.menu.entities.approvedRefund" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/external-referral">
        <Translate contentKey="global.menu.entities.externalReferral" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/health-camp-registration">
        <Translate contentKey="global.menu.entities.healthCampRegistration" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/tenant">
        <Translate contentKey="global.menu.entities.tenant" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/tenant-employee">
        <Translate contentKey="global.menu.entities.tenantEmployee" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/tenant-access">
        <Translate contentKey="global.menu.entities.tenantAccess" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/tenant-association">
        <Translate contentKey="global.menu.entities.tenantAssociation" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/tinymedic-patient-order">
        <Translate contentKey="global.menu.entities.tinymedicPatientOrder" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/tenant-bids">
        <Translate contentKey="global.menu.entities.tenantBids" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/tenant-bid-item">
        <Translate contentKey="global.menu.entities.tenantBidItem" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/tenant-bid-payment">
        <Translate contentKey="global.menu.entities.tenantBidPayment" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/tenant-bid-shipment">
        <Translate contentKey="global.menu.entities.tenantBidShipment" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/tinymedic-patient-order-file">
        <Translate contentKey="global.menu.entities.tinymedicPatientOrderFile" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/doctor-regular-medicine">
        <Translate contentKey="global.menu.entities.doctorRegularMedicine" />
      </MenuItem>
      {/* jhipster-needle-add-entity-to-menu - JHipster will add entities to the menu here */}
    </>
  );
};

export default EntitiesMenu;
